import { cn } from "@/utils/index";

function Marquee({
  children,
  direction = "left",
  pauseOnHover = false,
  reverse = false,
  className,
  innerClassName,
  numberOfCopies = 2,
  ...rest
}) {
  return (
    <div
      className={cn(
        "group flex gap-[1.5rem] overflow-hidden",
        direction === "left" ? "flex-row" : "flex-col",
        className
      )}
      {...rest}
    >
      {Array(numberOfCopies)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={cn(
              "flex justify-around gap-[1.5rem] [--gap:1.5rem] shrink-0",
              direction === "left"
                ? "animate-marquee-left flex-row"
                : "animate-marquee-up flex-col",
              pauseOnHover && "group-hover:[animation-play-state:paused]",
              reverse && "direction-reverse",
              innerClassName
            )}
          >
            {children}
          </div>
        ))}
    </div>
  );
}

export default Marquee;
